export const CopyChart = async (
  canvas: HTMLCanvasElement,
  htmlContent?: string,
  plainText?: string
): Promise<boolean> => {
  try {
    if (!canvas) return false;

    const blob = await new Promise<Blob | null>((resolve) =>
      canvas.toBlob((b) => resolve(b), 'image/png')
    );
    if (!blob) return false;

    const dataURL = canvas.toDataURL('image/png');

    const finalHtml = htmlContent
      ? `<div style="font-family: Arial, sans-serif;">
           <img src="${dataURL}" alt="Chart" style="display: block; margin-bottom: 10px; max-width: 100%;" />
           ${htmlContent}
         </div>`
      : `<div style="font-family: Arial, sans-serif;">
           <img src="${dataURL}" alt="Chart" style="display: block; max-width: 100%; margin-top: 12px;" />
         </div>`;

    await navigator.clipboard.write([
      new ClipboardItem({
        'image/png': blob,
        'text/html': new Blob([finalHtml], { type: 'text/html' }),
        ...(plainText && { 'text/plain': new Blob([plainText], { type: 'text/plain' }) }),
      }),
    ]);

    return true;
  } catch (error) {
    console.error('Failed to copy chart:', error);
    return false;
  }
};
